import { Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { HistoryItem } from './';

const ListEmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  background-color: #fff;
  width: 100%;
  height: 399px;
  overflow: hidden;

  @media (max-width: 1024px) {
    margin: 0 16px;
    width: calc(100% - 32px);
    height: 278px;
  }
`;

const Circle = styled.div`
  height: 616px;
  width: 616px;
  background-color: ${theme.GREY_10};
  border-radius: 616px;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1024px) {
    margin-top: 48px;
  }
`;

const History = ({}) => {
  const billingHistory = useSelector((state) => state.user.billingHistory),
    sortedHistory = billingHistory.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
    { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  return (
    <Col wid={isMobile ? '100vw' : '936px'}>
      {!isMobile && (
        <Row between>
          <Row marg="0 0 8px 23px">
            <Text c1 med marg="0 113px 0 0">
              {t('common.date')}
            </Text>

            <Text c1 med col={theme.GREY_60}>
              {t('common.description')}
            </Text>
          </Row>

          <Row marg="0 0 0 23px">
            <Text c1 med col={theme.GREY_60} marg="0 186px 0 0">
              {t('billing.paymentMethod')}
            </Text>

            <Text c1 med col={theme.GREY_60}>
              {t('common.amount')}
            </Text>
          </Row>
        </Row>
      )}

      {!billingHistory?.length ? (
        <ListEmptyContainer>
          <Circle>
            <Icon
              marg={!isMobile ? '80px 0 0' : '37px 0 0'}
              type="receipt"
              col={theme.GREY_30}
              dimensions={80}
            />

            <Text marg={!isMobile ? '32px 0 0' : '21px 0 0'} h4>
              {t('billing.noPaymentsYet')}
            </Text>

            <Text b2 center marg="8px 0 0" wid={isMobile ? '240px' : 'unset'}>
              {t('billing.processedPaymentsHere')}
            </Text>
          </Circle>
        </ListEmptyContainer>
      ) : (
        <Col wid="inherit" noFlex>
          {sortedHistory.map((x, i) => (
            <HistoryItem item={x} key={i} />
          ))}
        </Col>
      )}
    </Col>
  );
};

export default History;
